import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum SessionKvKey {
  READER_PANEL = "reader-panel",
  PREFERENCES_FAST_HIGHLIGHT_ENABLED = "preferences-fast-highlight-enabled",
  ONBOARDING_TYPE = "onboarding-type",
  QR_CODE_ONBOARDING_MODAL_DISABLED = "qr-code-onboarding-modal-disabled",
  ACTIVE_DIALOG = "active-dialog",
  AI_CHAT_LULL_MESSAGE_ID = "ai-chat-lull-message-id",
}

const kvSlice = createSlice({
  name: "sessionKv",
  initialState: {},
  reducers: {
    setSessionValue(
      state,
      action: PayloadAction<{
        key: SessionKvKey;
        value: unknown;
      }>
    ) {
      state[action.payload.key] = action.payload.value;
    },
  },
});

export default kvSlice.reducer;

export const { setSessionValue } = kvSlice.actions;

export function getSessionValue<T = unknown>(state, key: SessionKvKey): T {
  return state.sessionKv[key];
}
